
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        status: {
            type: Object as PropType<{ id: number }>,
            default: null,
        },
    },
})
